<template>
  <div>
    <Loading :isLoading="isLoading" />
    <div class="row">
      <div class="col-md-5">
        <div class="mb-3">
          <label for="password" class="form-label text-label"
            >Current Password*</label
          >
          <div class="position-relative">
            <input
              :type="showPasswordFields.currentPassword ? 'text' : 'password'"
              class="form-control pe-5"
              id="password"
              v-model="currentPassword"
            />
            <div
              class="position-absolute top-50 end-0 translate-middle-y pe-3"
              style="cursor: pointer"
              @click="togglePasswordVisibility('currentPassword')"
            >
              <svg
                v-if="!showPasswordFields.currentPassword"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye text-secondary"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                />
                <path
                  d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye-slash text-secondary"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
                />
                <path
                  d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
                />
                <path
                  d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
                />
              </svg>
            </div>
          </div>
          <span
            v-if="validationErrors.currentPassword"
            class="text-danger small"
            >{{ validationErrors.currentPassword }}</span
          >
          <div
            v-if="loginError"
            class="d-flex align-items-center text-danger small mt-1"
          >
            <i class="fas fa-exclamation-triangle"></i>
            <span>{{ loginError }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <div class="mb-3">
          <label for="newPassword" class="form-label text-label"
            >New Password*</label
          >
          <div class="position-relative">
            <input
              :type="showPasswordFields.newPassword ? 'text' : 'password'"
              class="form-control pe-5"
              id="newPassword"
              v-model="newPassword"
            />
            <div
              class="position-absolute top-50 end-0 translate-middle-y pe-3"
              style="cursor: pointer"
              @click="togglePasswordVisibility('newPassword')"
            >
              <svg
                v-if="!showPasswordFields.newPassword"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye text-secondary"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                />
                <path
                  d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye-slash text-secondary"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
                />
                <path
                  d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
                />
                <path
                  d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
                />
              </svg>
            </div>
          </div>
          <span v-if="validationErrors.newPassword" class="text-danger small">{{
            validationErrors.newPassword
          }}</span>
          <div
            v-if="loginError"
            class="d-flex align-items-center text-danger small mt-1"
          >
            <i class="fas fa-exclamation-triangle"></i>
            <span>{{ loginError }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <div class="mb-3">
          <label for="confirmPassword" class="form-label text-label"
            >Confirm Password*</label
          >
          <div class="position-relative">
            <input
              :type="showPasswordFields.confirmPassword ? 'text' : 'password'"
              class="form-control pe-5"
              id="confirmPassword"
              v-model="confirmPassword"
            />
            <div
              class="position-absolute top-50 end-0 translate-middle-y pe-3"
              style="cursor: pointer"
              @click="togglePasswordVisibility('confirmPassword')"
            >
              <svg
                v-if="!showPasswordFields.confirmPassword"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye text-secondary"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                />
                <path
                  d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye-slash text-secondary"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
                />
                <path
                  d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
                />
                <path
                  d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
                />
              </svg>
            </div>
          </div>
          <span
            v-if="validationErrors.confirmPassword"
            class="text-danger small"
            >{{ validationErrors.confirmPassword }}</span
          >
          <div
            v-if="loginError"
            class="d-flex align-items-center text-danger small mt-1"
          >
            <i class="fas fa-exclamation-triangle"></i>
            <span>{{ loginError }}</span>
          </div>
        </div>
      </div>
    </div>
    <button
      type="submit"
      class="btn btn-primary"
      @click="submit"
      :disabled="isLoading"
    >
      Change Password
    </button>
  </div>
</template>

<script>
import { buildFormData } from "../../utils/param-builder";
import { changePassword } from "../../api/auth";
import Loading from "../../components/Loading.vue";

export default {
  name: "ChangePassword",
  components: {
    Loading,
  },
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      showPasswordFields: {
        currentPassword: false,
        newPassword: false,
        confirmPassword: false,
      },
      validationErrors: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      loginError: "",
      isLoading: false,
    };
  },
  methods: {
    togglePasswordVisibility(field) {
      this.showPasswordFields[field] = !this.showPasswordFields[field];
    },
    validate() {
      this.validationErrors = {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      };

      let isValid = true;

      if (this.currentPassword === "") {
        this.validationErrors.currentPassword = "Current password is required.";
        isValid = false;
      }
      if (this.newPassword === "") {
        this.validationErrors.newPassword = "New password is required.";
        isValid = false;
      }
      if (this.confirmPassword === "") {
        this.validationErrors.confirmPassword = "Confirm password is required.";
        isValid = false;
      } else if (this.newPassword !== this.confirmPassword) {
        this.validationErrors.confirmPassword = "Passwords do not match.";
        isValid = false;
      }

      return isValid;
    },
    resetForm() {
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
    },
    async submit() {
      if (this.validate()) {
        this.isLoading = true;
        try {
          const body = {
            current_password: this.currentPassword,
            new_password: this.newPassword,
            new_password_confirmation: this.confirmPassword,
          };

          const formData = buildFormData(body);

          const response = await changePassword(formData);
          if (response.status === "success") {
            this.$swal("Success", "Change Password Success", "success");
            this.resetForm();
          } else {
            this.generalError = response.message || "Change password failed";
          }
        } catch (error) {
          console.error("Error during password change:", error);
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
